import { debounce } from 'underscore';

export const callWithDebounce = (method, debounceInMs) => (debounceInMs ? debounce(method, debounceInMs) : method);
